function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.487 0.83771C20.9497 0.375056 21.6998 0.375056 22.1624 0.837711C22.6251 1.30037 22.6251 2.05048 22.1624 2.51313L11.5001 13.1754C11.0375 13.6381 10.2874 13.6381 9.82473 13.1754C9.36208 12.7128 9.36208 11.9627 9.82473 11.5L20.487 0.83771Z",
  fill: "black"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.14 2.86012H15.4013C14.747 2.86012 14.2166 2.32971 14.2166 1.67542C14.2166 1.02113 14.747 0.490723 15.4013 0.490723H21.3247C21.979 0.490723 22.5094 1.02113 22.5094 1.67542V7.59892C22.5094 8.25321 21.979 8.78362 21.3247 8.78362C20.6705 8.78362 20.14 8.25321 20.14 7.59892V2.86012Z",
  fill: "black"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M17.7705 12.9301C17.7705 12.2758 18.3009 11.7454 18.9552 11.7454C19.6095 11.7454 20.1399 12.2758 20.1399 12.9301V19.594C20.1399 21.4751 18.615 23 16.7339 23H3.40601C1.52492 23 0 21.4751 0 19.594L2.82454e-06 6.26611C2.82454e-06 4.38503 1.52492 2.86011 3.40601 2.86011C8.18265 2.86011 8.18265 2.86011 10.6253 2.86011C11.2796 2.86011 11.81 3.39052 11.81 4.04481C11.81 4.6991 11.2796 5.22951 10.6253 5.22951C8.18264 5.22951 8.18264 5.22951 3.40601 5.22951C2.83351 5.22951 2.3694 5.69361 2.3694 6.26611L2.3694 19.594C2.3694 20.1665 2.8335 20.6306 3.40601 20.6306H16.7339C17.3064 20.6306 17.7705 20.1665 17.7705 19.594V12.9301Z",
  fill: "black"
});

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.765f4f1e.svg";
export { ForwardRef as ReactComponent };